import styled from 'styled-components'

export const FieldsContainer = styled.div`
    max-width: 340px;
    gap: 16px;
    margin: 0 12px;
    display: flex;
    flex-direction: column;
`
